import { ProjectData, OptionsAssignee, AvailabilityAssignee, OptionsHardware, AvailabilityHardware } from '~/actions/agile';
import { ActionsProject } from '~/actions/project.action';

interface ProjectERPStore {
  project: ProjectData
  optionsAssignee: OptionsAssignee
  availabilityAssignee: AvailabilityAssignee[]
  optionsHardware: OptionsHardware[]
  availabilityHardware: AvailabilityHardware[]
}
const initialAuth: ProjectERPStore = {
  project: null,
  optionsAssignee: { teamCount: [{ name: '', category: '' }], erpUser: [{ avatar: '', category: '', color: '#ccc', name: '' }] },
  availabilityAssignee: [{ name: '', availability: [{ start: new Date(), end: new Date() }] }],
  optionsHardware: [{ value: '', category: '' }],
  availabilityHardware: [{ name: '', availability: [] }],
};

const projectReducer = (state = initialAuth, action: ActionsProject):ProjectERPStore => {
  switch (action.type) {
  case 'set_actual_project':
    // console.log('actual project', action.payload);
    return {
      ...state,
      project: action.payload,
    };
  case 'initialize_actual_project':
    return {
      ...state,
      project: null,
    };
  case 'set_options_assignee':
    return {
      ...state,
      optionsAssignee: action.payload,
    };
  case 'set_availability_assignee':
    return {
      ...state,
      availabilityAssignee: action.payload,
    };
  case 'set_options_hardware':
    return {
      ...state,
      optionsHardware: action.payload,
    };
  case 'set_availability_hardware':
    return {
      ...state,
      availabilityHardware: action.payload,
    };
  case 'set_project_metadata':
    return{
      ...state,
      availabilityAssignee:action.payload.availabilityAssignee,
      availabilityHardware:action.payload.availabilityHardware,
      optionsAssignee:action.payload.optionsAssignee,
      optionsHardware:action.payload.optionsHardware
    }

  default:
    return state;
  }
};

export default projectReducer